export default __webpack_public_path__ + "static/media/hht2_Intonation_05.03d1160b.png";